"use strict";
var getMapData = require('./_getMapData');
function mapCacheSet(key, value) {
    var data = getMapData(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
module.exports = mapCacheSet;
//# sourceMappingURL=_mapCacheSet.js.map